export default "<body>\r\n  <app-nav-menu></app-nav-menu>\r\n\r\n  <router-outlet></router-outlet>\r\n</body>\r\n"